import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Toaster } from 'sonner';

export const Layout = ({ children, title = 'Dashboard' }) => {
    return (
        <div className="app-container" data-testid="app-layout">
            <Sidebar />
            <main className="main-content">
                <Header title={title} />
                <div className="page-content">
                    {children}
                </div>
            </main>
            <Toaster position="top-right" richColors />
        </div>
    );
};
